<template>
  <div
    class="page-body container mx-auto flex flex-col justify-start items-center font-heiti"
  >
    <div class="flex flex-col justify-start items-center space-y-2 mt-36">
      <img alt="" :src="logo1" class="h-32" />
      <div class="text-center pt-1">（股票代码：300597.SZ）</div>
      <div
        class="mx-auto w-96 border-b border-solid border-blue-level pt-2"
      ></div>
      <div class="space-x-5 pt-2">
        <span>明德</span><span>笃志</span><span>创新</span><span>共赢</span>
      </div>
      <div>通信与信息数字技术综合服务专家，</div>
      <div>通信网络、数字社会、绿色低碳生活的卓越建设者。</div>
    </div>
    <div class="flex flex-col justify-start items-center mt-28 space-y-2">
      <img alt="" :src="logo2" class="h-32" />
      <div
        class="mx-auto w-96 border-b border-solid border-blue-level pt-3"
      ></div>
      <div class="pt-2">整合资源、搭建生态，</div>
      <div>以检验检测技术为核心，</div>
      <div>为全行业、全产业链提供综合性质量保障服务。</div>
    </div>
  </div>
</template>

<script>
// 封面
export default {
  props: ["info"],
  data() {
    return {
      logo1: "/buckets/static_images/logo_1.png",
      logo2: "/buckets/static_images/logo_2.png",
    };
  },
};
</script>
